import axios from 'axios'
import store from '@/store'
import router from '@/router'
import { message } from '@/util/resetMessage';

//拦截器
axios.defaults.timeout = 60000000;

axios.interceptors.request.use(config => {
	return config;
}, error => {
	message.error("数据加载超时");
	return Promise.reject(error)
})

// http响应拦截器
axios.interceptors.response.use(response => {
		if(response.status == 200) {
			if(response.data.ResultMsg === "您无权限操作此页面") {
				message.error(response.data.ResultMsg);
				router.push({
					path: '/Login'
				})
			};
			return response.data
		} else {
			message.error(response.data.ResultMsg);
		}
	},
	error => {
		if(error.response) {
			switch(error.response.status) {
				case 400:
					message.error('请求出错')
					break
				case 401:
					message.warning({
						message: '授权失败，请重新登录'
					})
					break
				case 403:
					message.warning({
						message: '拒绝访问'
					})
					break
				case 404:
					message.warning({
						message: '请求错误,未找到该资源'
					})
					break
				case 415:
					message.warning({
						message: '请求错误'
					})
					break;
				case 500:
					message.warning({
						message: '服务端错误'
					})
					break;
			}
		}
		return Promise.reject(error.response.ResultMsg) // 返回接口返回的错误信息
	});

export default axios;


// WEBPACK FOOTER //
// ./src/util/api.js